import type { Language } from '../types';

export function formatRelativeTime(dateString: string | null | undefined, language: Language): string {
  if (!dateString) return '';

  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return '';

  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return language === 'zh' ? '刚刚' : 'Just now';
  if (diffMins < 60) return language === 'zh' ? `${diffMins} 分钟前` : `${diffMins}m ago`;
  if (diffHours < 24) return language === 'zh' ? `${diffHours} 小时前` : `${diffHours}h ago`;
  if (diffDays < 7) return language === 'zh' ? `${diffDays} 天前` : `${diffDays}d ago`;

  return date.toLocaleDateString(language === 'zh' ? 'zh-CN' : 'en-US', { month: 'short', day: 'numeric' });
}

